import { Link } from 'react-router-dom';
import { useClientTranslation } from '@/lib/core/i18n';
import { ErrorBoundary } from './boundary';

export function UnexpectedError({ error }: { error?: ErrorBoundary }) {
  const translation = useClientTranslation();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-4">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-gray-200">{translation('App.Labels.Error')}</h1>
        <h2 className="mt-4 text-3xl font-semibold text-gray-800">
          {translation('App.Labels.SomethingWentWrong')}
        </h2>
        <p className="mt-2 text-gray-600">
          {error?.state.error?.message || translation('App.Labels.UnexpectedErrorOccurred')}
        </p>
        <div className="mt-6 flex justify-center gap-4">
          <button
            onClick={() => error?.setState({ hasError: false })}
            className="rounded-lg bg-gray-600 px-6 py-3 text-white transition-colors hover:bg-gray-700"
          >
            {translation('App.Labels.TryAgain')}
          </button>
          <Link
            to="/"
            className="inline-block rounded-lg bg-blue-600 px-6 py-3 text-white transition-colors hover:bg-blue-700"
          >
            {translation('App.Labels.GoHome')}
          </Link>
        </div>
      </div>
    </div>
  );
}
